module.exports = __webpack_public_path__ + "static/media/engine.8a28eea6.jpg";